import eventBus from '../../vue-functions/event-bus';

function resetSmallGroupsFlag() {
  eventBus.$emit('reset-small-groups-flag');
  this.$data.settings.filters.tags = [];
  this.$data.settings.filtersValues.tags = [];
  this.$data.settings.tags = '';
}
export default resetSmallGroupsFlag;
